"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Accordions = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _Accordion = require("../Accordion");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Accordions component is used to render group of Accordion components. Uses Accordion, AccordionSummary and AccordionDetails from @ori-ui/mui.
 * If `expandedAccordions` is not provided, component will manage its own state of expanded items.
 * If `expandedAccordions` is provided, state of expanded items will be controlled externally.
 */
const Accordions = ({
  items,
  className,
  mode = 'multipleExpanded',
  defaultExpanded = [],
  expandedAccordions: externalExpandedAccordions,
  onAccordionChange: externalOnAccordionChange
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [expandedAccordions, setExpandedAccordions] = (0, _react.useState)(defaultExpanded);
  const onAccordionChange = (0, _react.useCallback)(id => () => {
    setExpandedAccordions(previousExpanded => {
      if (mode === 'oneExpanded') {
        return previousExpanded.includes(id) ? [] : [id];
      }
      return previousExpanded.includes(id) ? previousExpanded.filter(expandedId => expandedId !== id) : [...previousExpanded, id];
    });
  }, [mode]);
  const expanded = (0, _react.useMemo)(() => externalExpandedAccordions ?? expandedAccordions, [expandedAccordions, externalExpandedAccordions]);
  const isControlledExternally = externalExpandedAccordions !== undefined;
  const onChange = (0, _react.useMemo)(() => isControlledExternally && externalOnAccordionChange ? externalOnAccordionChange : onAccordionChange, [externalOnAccordionChange, isControlledExternally, onAccordionChange]);
  if (items.length === 0) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.ACCORDIONS),
    children: items.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Accordion.Accordion, {
      accordionProps: {
        expanded: expanded.includes(item.id),
        onChange: onChange(item.id)
      },
      ...item
    }, item.id))
  });
};
exports.Accordions = Accordions;
//# sourceMappingURL=Accordions.js.map